var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2 py-1 relative"},[_vm._v(" "+_vm._s(_vm.item[_vm.column].length)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }